import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { DatePicker } from './datePicker.component';
import {
  selectBookingDate,
  BookingActions,
  selectDisabledWeekdays,
  selectFirstAvailableDate,
} from '../../../../modules/booking';
import { selectCurrentExperience, selectCurrentExperienceTimezone } from '../../../../modules/experience';

const mapStateToProps = createStructuredSelector({
  activeDate: selectBookingDate,
  timezone: selectCurrentExperienceTimezone,
  disabledWeekdays: selectDisabledWeekdays,
  firstAvailableDate: selectFirstAvailableDate,
  experience: selectCurrentExperience,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onDateSelected: BookingActions.selectDate,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(DatePicker);
